module.exports = __webpack_public_path__ + "img/dd.63a13d82.png";